/*
	Name:         blog.js
	Description:  MultiView Blog script for the theme.
	Version:      1.0.0
	Author:       GH Advertising
*/

(function ($) {
    $(function () {
        const buffer = 750;
        const $block = $(".o-card-grid");

        if (!$block.length) {
            return;
        }

        let timer,
            loading = false;
        const $grid = $block.find(".o-card-grid__grid"),
            $currentPage = $block.find("input[name=page]"),
            $exclude = $block.find("input[name=exclude]"),
            $catFilter = $("#filter-by-category"),
            $loadInsights = $("#loadPosts"),
            $button = $block.find(".o-card-grid__button"),
            $loader = $("#loadingView"),
            $html = $("html");

        function updateUrl(category, url) {
            if (typeof history.pushState != "undefined") {
                const newUrl = "?" + category + "=" + encodeURIComponent(url);
                const obj = { Page: category, Url: newUrl };
                history.pushState(obj, "", obj.Url);
            }
        }

        function clearUrl() {
            const refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + "";
            window.history.pushState({ path: refresh }, "", refresh);
        }

        $block
            .on("submit", ".m-filter", (e) => {
                e.preventDefault();
                $grid.empty();
                $block.trigger("gh:update", [1]);
            })
            .on("change", ".a-input-field select", (e) => {
                if ($catFilter.length && $(e.currentTarget).is($catFilter)) {
                    const selected = $catFilter.find("option:selected");
                    const slug = selected.data("slug");
                    const value = $catFilter.val();
                    if (value) {
                        updateUrl("category", slug || value);
                    } else {
                        clearUrl();
                    }
                }
                $grid.empty();
                $block.trigger("gh:update", [1]);
            })
            .on("input", ".a-input-field input[type=search]", () => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    $grid.empty();
                    $block.trigger("gh:update", [1]);
                }, buffer);
            })
            .on("gh:update", (e, page) => {
                if (loading) {
                    return;
                }
                loading = true;
                $loader.fadeIn();
                $html.addClass("overflow-hidden");
                clearTimeout(timer);
                const $form = $(".m-filter");
                const $pager = $form.find(".a-input-field input[name=page]");
                $pager.val(page);

                const data = $form
                    .serializeArray()
                    .filter(({ value }) => !!value)
                    .map(({ name, value }) => (value === "true" ? name : `${name}=${value}`))
                    .join("&");

                $.ajax({
                    url: $form[0].action,
                    method: $form[0].method,
                    data,
                    success(data, status, xhr) {
                        $grid.trigger("gh:render", [data]);
                        $pager.trigger("gh:page", [page, parseInt(xhr.getResponseHeader("X-Wp-Totalpages"), 10)]);
                        $loader.fadeOut();
                        $html.removeClass("overflow-hidden");
                    },
                    complete() {
                        loading = false;
                    },
                });
            })
            .on("gh:page", (e, page, total) => {
                if (page < total) {
                    $currentPage.val(parseInt(page) + 1);
                    $loadInsights.removeAttr("disabled").text("Load More Blog Posts");
                } else {
                    $loadInsights.attr("disabled", "disabled").text("No More Blog Posts");
                }
            });

        $grid.on("gh:render", (e, data) => {
            if (data.length) {
                $.each(data, (i, item) => {
                    const blogPost = new BlogPost(item);
                    $grid.append(blogPost.render());
                });
                revealBlogPosts();
            } else {
                $grid.html("<h2>Sorry, no results found.</h2>");
            }
        });

        const loadMore = (loadButton) => {
            loadButton.on("click tap", (e) => {
                e.preventDefault();
                const $loadButton = $(e.currentTarget);
                let page = $currentPage.val();
                if (!$loadButton.is(".a-button--disabled")) {
                    $block.trigger("gh:update", [page]);
                }
            });
        };

        const revealBlogPosts = () => {
            $(".m-card--post", $grid).each(function (index) {
                const row = $(this);
                setTimeout(function () {
                    row.addClass("m-card--show");
                }, 50 * index);
            });
        };

        loadMore($loadInsights);

        let didPrefilter = false;
        if ($catFilter.length) {
            const urlParams = new URLSearchParams(window.location.search);
            const categoryParam = urlParams.get("category");

            if (categoryParam) {
                const matchBySlug = $catFilter.find(`option[data-slug="${categoryParam}"]`);

                if (matchBySlug.length) {
                    matchBySlug.prop("selected", "selected");
                    $catFilter.trigger("change");
                    didPrefilter = true;
                } else {
                    const categoryId = parseInt(categoryParam, 10);

                    if (!Number.isNaN(categoryId)) {
                        $catFilter.val(categoryId).trigger("change");
                        didPrefilter = true;
                    }
                }
            }
        }

        if (!didPrefilter) {
            $grid.empty();
            $block.trigger("gh:update", [1]);
        }
    });
})(jQuery);
